import { useState } from "react";
import { useDispatch } from "react-redux";
import { getWebText } from "../api/ApiService";
import { EpiId } from "../shared/enums/LinkEpiId";
import { cookies } from "../shared/helpers/cookies";
import { action } from "../store/action";

export const useWebLinkData = () => {
  const [isWebLinkLoaded, setIsWebLinkLoaded] = useState<boolean>(false);
  const dispatch = useDispatch();
  const cookieMarket = cookies.getMarket();
  let market = cookieMarket ? cookieMarket : "en";
  if (cookieMarket === "nl-BE" || cookieMarket === "fr-BE") {
    market = "nl-NL";
  }
  if (cookieMarket === "en-CA") {
    market = "en-US";
  }
  const loadWebLinkData = () => {
    setIsWebLinkLoaded(true);
    for (const value of Object.values(EpiId)) {
      if (!isNaN(Number(value))) {
        getWebText(`retailerlink/?contentLink=${value}&language=${market}`).then(
          (result) => {
            dispatch(
              action.saveEpiLink({
                result: result,
                type: value,
              })
            );
          }
        );
      }
    }
  };

  return {
    loadWebLinkData,
    isWebLinkLoaded,
  };
};
